import {apiDomain} from "../config"
import getAPI from "../baseGetAPI";

function getMerchantUserContactInfoAPI(token, successCallback, failCallback){
    getAPI(`${apiDomain}merchantuser/query/muser?access_token=${token}`, successCallback, failCallback);
}

export default getMerchantUserContactInfoAPI;
